import 'primary/activities/Modals/PendingEventParticipationsInvitation.scss';

import { Cancel } from '@mui/icons-material';
import { Box, Divider, IconButton } from '@mui/material';
import { EventParticipant } from 'domain/event/participants/EventParticipant';
import { PlayerRoleEnum } from 'domain/event/PlayerRoleEnum';
import { UserProfilView } from 'domain/user/UserProfilView';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { TagPlayer } from 'primary/Components/TagPlayer/TagPlayer';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import { ActionButtonsForContent } from 'primary/MessageList/contents/ActionButtonsForContent';
import { getOnClickResponseEventParticipation } from 'primary/MessageList/contents/NotificationParticipationEventContent';
import ModalContainer from 'primary/ModalContainer/ModalContainer';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type ModalPendingEventParticipationsInvitationProps = {
  isOpen?: boolean;
  handleClose: () => void;
  invitationList: EventParticipant[];
  afterSubmit: () => void;
  loading?: boolean;
};

export const ModalPendingEventParticipationsInvitation = ({
  isOpen,
  handleClose,
  afterSubmit,
  invitationList,
  loading,
}: ModalPendingEventParticipationsInvitationProps) => {
  const t = useTranslate();
  return (
    <ModalContainer
      handleClose={handleClose}
      isOpen={!!isOpen}
      content={
        <Box className={'modal-pending-event-participation-invitation'}>
          <div className={'-header'}>
            <h2>{t('modals.pendingEventParticipationsInvitation.title')}</h2>
            <IconButton onClick={() => handleClose()}>
              <Cancel />
            </IconButton>
          </div>
          <ListPendingEventParticipationsInvitation
            invitationList={invitationList}
            afterSubmit={afterSubmit}
            loadingFromButton={loading}
          />
        </Box>
      }
    />
  );
};

type ListPendingEventParticipationsInvitationProps = {
  invitationList: EventParticipant[];
  afterSubmit: () => void;
  loadingFromButton?: boolean;
};

const ListPendingEventParticipationsInvitation = ({
  invitationList,
  afterSubmit,
  loadingFromButton,
}: ListPendingEventParticipationsInvitationProps) => {
  const [loading, setLoading] = useState(false);
  const { eventParticipantRepository } = useContextDependency();
  const t = useTranslate();
  const navigate = useNavigate();
  return (
    <div className={'-listPendingEventParticipationsInvitation'}>
      {invitationList?.map((invitation) => {
        return (
          <div key={invitation?.id} className={'-pendingEventParticipationsInvitation'}>
            <TagPlayer
              embed
              player={
                invitation.team.players.find((p) => p.role === PlayerRoleEnum.CHIEF)
                  ?.player as UserProfilView
              }
            />
            <Divider />
            <div className={'-infos'}>
              <div className={'-eventParticipationInfos'}>
                <KeyValue
                  className={'-margedRight'}
                  accent
                  keyValue={'Équipe :'}
                  value={invitation.team.name}
                />
                <KeyValue
                  className={'-margedRight'}
                  accent
                  keyValue={'Event :'}
                  value={invitation.event.name}
                />
              </div>
            </div>
            <Divider />
            <div className={'-footerActions'}>
              <ActionButtonsForContent
                loading={loadingFromButton || loading}
                onClickCancel={getOnClickResponseEventParticipation(
                  eventParticipantRepository,
                  t,
                  false,
                  afterSubmit,
                  invitation.id,
                  invitation.event.id,
                  setLoading,
                )}
                onClickValid={getOnClickResponseEventParticipation(
                  eventParticipantRepository,
                  t,
                  true,
                  afterSubmit,
                  invitation.id,
                  invitation.event.id,
                  setLoading,
                )}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
